module.exports = __webpack_public_path__ + "img/debtnote-icon.d5ebb8ab.png";